import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from 'app/globals';
// import { setTimeout } from 'timers';
declare var jquery: any;
declare var $: any;
import { PurchaseAssessmentModalComponent } from '../../purchase-assessment-modal/purchase-assessment-modal.component';
import { ToastrService } from 'ngx-toastr';
import { GridOptions } from "ag-grid/main";
import { Router } from '@angular/router';
import { isUndefined } from 'util';
import { CoachService, AssessmentAssignmentDto } from 'app/services/coach/CoachService';
import { TemplatesService, EmailTemplateDto, LocalizationsEmailTemplate } from 'app/services/template/TemplatesService';
import { AdminService } from 'app/services/admin/AdminService';
import { RaterTypesForModalComponent } from '../c-rater-types/rater-types-for-modal/rater-types-for-modal.component';
import { RatersService } from 'app/services/rater/RatersService';
import { AssignAssessmentModalComponent } from '../../assign-assessment-modal/assign-assessment-modal.component';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class CoachHomeComponent implements OnInit {

    @ViewChild('purchaseAssessment', {static: true}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    @ViewChild('raterTypesForModal', {static: true}) public raterTypesForModal: RaterTypesForModalComponent;
    @ViewChild('assignAssessment', {static: true}) public assignAssessmentModal: AssignAssessmentModalComponent;

    data: any[] = [];
    loaded: boolean = false;
    counter: number = 0;
    assessmentsRegular: number;
    assessments360: number;
    clientsAmount: number;
    emails: number;
    action = "Add";
    currentClientId: number;
    standardData: any[] = [];
    standardDataHeaders: any[];

    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridApiStandard;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    loading: boolean = false;

    rowSelection: string;

    currentTemplateId: number;

    name: any;
    purpose: any;
    userType: any;
    type: any;
    niche: any;
    localizations: any;
    htmlBody: string = null;
    language: any;
    body: string;
    subject: string;
    public editor;
    public editorContent = ``;
    public editorOptions = { placeholder: "insert content..." };
                                                                 
    imageThumbnailUrl: string = "https://ipeceli.file.core.windows.net/pictures/logos/Video_thumbnail_coaching_logo.png";
    mediaJSON = {
        "tiles": [
            {
                "title": "Getting Started",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/assest-df213252-e5b0-483b-b967-2a59917f6d22/ELI%20Tutorial%20-%20Getting%20Started.mp4",
            },               
            {
                "title": "Assigning Assessments",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-e088004f-9c45-4ec2-9f6c-046211b7917f/ELI%20Tutorial%20-%20Assigning%20Assessments.mp4",
            },
            {
                "title": "Managing Clients",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-4065ec28-4212-465a-8908-9750f9bcf340/ELI%20Tutorial%20-%20Managing%20Clients.mp4",
            },
            {
                "title": "Managing Assessments Part 1 - ELI Self Assessment",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-e59774ed-d3c0-479d-a157-ec5227962abc/ELI%20Tutorial%20-%20Managing%20Assessments%20Part%201%20-%20ELI%20Self%20Assessment.mp4",
            },
            {
                "title": "Managing Assessments Part 2 - ELI 360 Assessment",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-216b6474-f8e0-4300-89e2-2328a5a8dbf2/ELI%20Tutorial%20-%20Managing%20Assessments%20Part%202%20-%20ELI%20360%20Assessment.mp4",
            },
            {
                "title": "Managing Email Templates",
                "description": "",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-191dde30-c915-4af7-81be-6f8a207e63bb/ELI%20Tutorial%20-%20Managing%20Email%20Templates.mp4",
            },
            // {
            //     "title": "Tutorial 7",
            //     "description": "Customizing Email Templates",
            //     "imageUrl": this.imageThumbnailUrl,
            //     "videoUrl": "https://ipeceli.blob.core.windows.net/asset-8a002560-a89d-4ccd-8f2e-b916070ba29b/Tutorial%207_%20Customizing%20Email%20Templates.mp4?sv=2017-04-17&sr=c&si=48c04fca-e89b-4153-b24c-cc4e66cc5206&sig=d0QZq9qEidirRoeIoRaQmH0isVtWKHboAchpem8kS14%3D&st=2019-12-20T21%3A07%3A26Z&se=2119-12-20T21%3A07%3A26Z",
            // },
        ]
    };

    announcements: any[] = [];
    media: boolean = true;

    //preview template modal attributes
    templateFields: any[] = [];
    customize: boolean = false;

    purposes: any[] = [];
    types: any[] =
        [{
            "Name": "Regular",
            "Id": 1
        },
        {
            "Name": "360",
            "Id": 2
        }
        ];
    niches: any[] = [];
    userTypes: any = [];
    languages: any = [];


    //----assign modal attributes-------
    currentPage = 1;
    assessmentName: string = "";
    amount: number;
    currentAmount: number = 0;
    enoughAmount: boolean = true;

    date1: Date = new Date();
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };

    hours: string[] = [
        "00:00 AM",
        "01:00 AM",
        "02:00 AM",
        "03:00 AM",
        "04:00 AM",
        "05:00 AM",
        "06:00 AM",
        "07:00 AM",
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM",
        "06:00 PM",
        "07:00 PM",
        "08:00 PM",
        "09:00 PM",
        "10:00 PM",
        "11:00 PM",
    ];
    

    templates:any = {
        invitation: "",
        reminder: "",
        result: ""
    }
    raterTemplates:any = {
        invitation: "",
        reminder: ""
    }

    invitationTemplates: any[] = [];
    reminderTemplates: any[] = [];
    resultTemplates: any[] = [];

    invitationTemplatesModel: string;
    reminderTemplatesModel: string;
    resultTemplatesModel: string;

    raterInvitations: any[] = [];
    raterReminders: any[] = [];
    raterInvitation: any = 0;
    raterReminder: any = 0;

    currentEditedType: string = "";
    assessmentId: number;
    is360: boolean = false;
    customTemplates: boolean = false;
    saving: boolean = false;

    clientIds: number[] = [];

    scheduledDate: string;
    expiresIn: any;
    selectedHour: string;
    selectedGtmText: string;
    selectedGtmValue: any;
    scheduleSelected: string = "0";

    //assessments grid
    assessmentsGridApi;
    //assessments: any[] = [];
    assessmentsELIData: any[] = [];
    assessments360Data: any[] = [];
    assessmentsHeaders: any[] = [];
    assessmentsRowSelection;
    selectedAssessment: any[] = [];
    assessmentsGridOptions: GridOptions;

    //clients grid
    clientsGridApi
    clients: any[] = [];
    clientsHeaders: any[];
    clientsGridOptions: GridOptions;
    clientsRowSelection;
    selectedClients: any[] = [];

    fromAddClient: number;
    savingClient: boolean = false;
    setTheLastOption: boolean = false;
    enableFilter: boolean = false;

    currentNode: any;
    selectedClientsIds: any[] = [];

    fileName: string = "";
    blobFile: any = null;
    //filters: string[] = ['Email', 'FirstName', 'LastName'];
    currentHour: any;
    tags = [];
    assessmentsRegularGridApi: any;
    assessments360GridApi: any;
    currentAssessmentTypeSelected: number;
    showCheckBox: boolean;
    importType: number;
    importedRaters: any[] = [];
    currentRatertype: any;
    raterTypes: any[] = [];
    addedRaters: any[] = [];
    raterGridApi;
    /*new rater*/
    rater = {
        email: "",
        firstName: "",
        lastName: "",
        RaterType: {
            Id: 0,
            Name: ""
        }
    }
    addRaterPageIdx: number = 0;
    canDeleteRaters: boolean = false;
    canEdit: boolean = false;
    ratersHeaders: any[];
    ratersRowSelection;

    invEma: boolean = false;
    remEma: boolean = false;
    resEma: boolean = false;
    ratInv: boolean = false;
    ratRem: boolean = false;

    relationshipAction: string = "Add";
    rowNodeId: string = "";
    modalIndex: number;
    videoModalTitle: string = "";
    videoModalDescription: string;
    pageName: string = "home";
    currentVideoUrl: string;
    playingVideo: boolean = false;

    currentAnnouncement: string = "";
    currentAnnouncementIdx: number = 0;
    displayBackArrow: boolean = false;
    displayNextArrow: boolean = false;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _RatersService: RatersService,
        private _TemplatesService: TemplatesService,
        private _Globals: Globals,
        private toastr: ToastrService,
        private router: Router
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "single";
        this.assessmentsRowSelection = "single";
        this.clientsRowSelection = "multiple";
        this.ratersRowSelection = "multiple";
    }
    
    ngOnInit() {
        //var x = Math.floor((Math.random() * 12) + 1);
        //console.log("x",x);
        //this.videoSource = this.mediaJSON.videos[x].sources["0"];

        $('.responsive-nav li').removeClass('active').eq(0).addClass('active');

        this.getLanguages();
        //this.getNiches(); 
        this.getTemplatePurposes();
        this.getUserTypesByTemplateType();
        //this.generateRamdomNum();
        this.getCoachDashboardInfo();
        this.getGlobalEmailTemplates();

        this.gridOptions = {};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.standardDataHeaders = this.standardDataCreateHeaders();
        //setTimeout(() => {
        //    this.loaded = true; 
        //}, 5000);


        /*ASSIGN MODAL*/
        //assessments
        //this.getCoachAvailableAssessments();
        this.getCoachAvailableAssessmentsByType(1);
        this.getCoachAvailableAssessmentsByType(2);
        this.assessmentsGridOptions = {};
        this.assessmentsGridOptions.rowHeight = 45;
        this.assessmentsGridOptions.headerHeight = 40;

        //clients
        this.getCoachClients();
        this.clientsGridOptions = {};
        this.clientsGridOptions.rowHeight = 45;
        this.clientsGridOptions.headerHeight = 40;

        if (this._Globals.coachResultsDisplayToast) {
            this.toastr.error('You are not authorized to access the requested page', 'ELI', {
                disableTimeOut: true
            });
            this._Globals.coachResultsDisplayToast = false;
        }
    }

    ngOnDestroy() {
        this._Globals.purchaseFromHome = false;
        //if (this.playingVideo) {
            //this.router.navigate(['/app/coach_home']);
            //this.closeVideoModal();
            //return;
        //}
    }

    //toggleMedia() {
    //    this.media = !this.media;
    //    if (!this.media) {
    //        this.createVideo();
    //    }
    //}

    showToggle() {
        $('.toggleBtn').toggleClass('toggleToggle');
    }

     createVideo(videoUrl:string) {
        //$('#video').get(0).play();
        //document.getElementById('video').play();
        setTimeout(() => {
            var video = $('<video />', {
                type: 'video/mp4',
                src: videoUrl,
                controls: true,
                height: '100%',
                width: '100%',
                autoplay: true,
            });
            $('.video-container').html(video);
            $('video').trigger('play');
        }, 500);
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async generateRamdomNum() {
        while (!this.loaded) {
            await this.sleep(25);
            this.counter = Math.floor((Math.random() * 99) + 1);
            console.log(this.counter);
        }
    }

    getCoachTotalAvailableAssessments(status: boolean) {
        this._CoachService.getCoachTotalAvailableAssessments(status).subscribe((data: any) => {
            console.log(data.result.Data);
            if (status) {
                this.assessments360 = data.result.Result; 
            } else {
                this.assessmentsRegular = data.result.Result;
            }
        });
    }

    getCoachTotalAssignedAssessments(status: boolean) {
        this._CoachService.getCoachTotalAssignedAssessments(status).subscribe((data: any) => {
            console.log(data.result.Data);
            if (status) {
                this.assessments360 = data.result.Result;
            } else {
                this.assessmentsRegular = data.result.Result;
            }
        });
    }

    getCoachTotalCompletedAssessments(status: boolean) {
        this._CoachService.getCoachTotalCompletedAssessments(status).subscribe((data: any) => {
            console.log(data.result.Data);
            if (status) {
                this.assessments360 = data.result.Result;
            } else {
                this.assessmentsRegular = data.result.Result;
            }
        });
    }

    getCoachDashboardInfo() {
        this._CoachService.getCoachDashboardInfo().subscribe((data: any) => {
            console.log("response_GetCoachDashboardInfo", data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;

                this.announcements = _data.Announcements;

                let announcementsStatus = this._Globals.getAnnouncementsStatus();
                console.log('announcementsStatus', announcementsStatus);

                if (this.announcements.length > 0) {
                    console.log('announcements.length', this.announcements.length);
                    this.currentAnnouncement = this.announcements[0].Text;
                    if (this.announcements.length > 1) this.displayNextArrow = true;
                    if (announcementsStatus) {
                        this.showAnnouncementsModal();
                    }
                }

                this.assessmentsRegular = _data.ELIAssessments;
                this.assessments360 = _data.Assessments360;
                this.clientsAmount = _data.Clients;
                this.emails = _data.EmailTemplates;

                for (var propName in this.data) {
                    console.log("Iterating through prop with name", propName, " its value is ", this.data[propName]);
                }
                this.loaded = true;

                //if (!this.media) {
                //    this.createVideo();
                //}
            } 
        });
    }

    //ngDoCheck() {
    //    console.log("ngDoCheck");
    //}

    getCoachTotals(type:string, status:boolean) {
        console.log(type);
        console.log(status);

        if (status) {
            switch (type) {
                case 'Available':
                    this.getCoachTotalAvailableAssessments(true);
                    break;
                case 'Assigned':
                    this.getCoachTotalAssignedAssessments(true);
                    break;
                case 'Completed':
                    this.getCoachTotalCompletedAssessments(true);
                    break;
            }
        } else {
            switch (type) {
                case 'Available':
                    this.getCoachTotalAvailableAssessments(false);
                    break;
                case 'Assigned':
                    this.getCoachTotalAssignedAssessments(false);
                    break;
                case 'Completed':
                    this.getCoachTotalCompletedAssessments(false);
                    break;
            }
        }
    }

    /*Purchase Modal*/
    openPurchaseModal() {
        this._Globals.purchaseFromHome = true;
        this.purchaseAssessmentModal.show(this);
    }

    /*Assign Modal*/
    openAssignModal() {
        this.assignAssessmentModal.selectedAssessment = [];
        this.assignAssessmentModal.showAssignModal(this, 1);
    }

    /*Add client modal*/
    showAddClientModal(from:number) {
        //client 1
        //assign 2
        this.fromAddClient = from;
        $('#cemail').val('');
        this.action = "Add";
        $('#caddClientModal').modal('show');
    }

    closeModal() {
        $('#caddClientModal').modal('hide');
        $('#cname').val('');
        $('#clast').val('');
    }

    preventSpace(value: string, event: any, id: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#' + id + '').val('');
        }
    }

    //deselectFilter(filterName) {
    //    var filterComponent = this.clientsGridApi.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.clientsGridApi.onFilterChanged();
    //}

    //toggleFilter() {
    //    if (this.enableFilter) {
    //        $('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //        if (this.clients.length === 0) {
    //            $('#clientsGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //        }
    //        console.log('hide filter');
    //        this.filters.forEach((item) => {
    //            this.deselectFilter(item);
    //        });
    //    } else {
    //        $('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "0", "position": "absolute", "width": "100%", "height": "100%" });
    //        if (this.clients.length === 0) {
    //            $('#clientsGrid .ag-body-viewport.ag-layout-normal').css('background', 'transparent');
    //        }
    //        //$('.ag-floating-filter-input').eq(0).closest('.ag-header-cell').hide();
    //    }
    //    this.enableFilter = !this.enableFilter;
    //}

    addClient(email: string, name: string, last: string) {
        
        console.log("email", email);
        $('body').css('cursor', 'wait');

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            if (name != "" && last != "") {
                this.saveCoachClient(email, name, last);
            } else {
                this.toastr.warning('Please complete all the fields.', "ELI");
                $('body').css('cursor', 'default');
            }

        } else {
            this.toastr.warning('Please enter a valid email address', "ELI");
            $('body').css('cursor', 'default');
        }
    }

    saveCoachClient(email: string, name: string, last: string) {
        this.savingClient = true;
        this._CoachService.postSaveCoachClient(email, name, last).subscribe(data => {
            console.log('response_PostSaveCoachClient', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    //client 1
                    //assign 2
                    if (this.fromAddClient == 1) {
                        this.getCoachDashboardInfo();
                    } else {
                        this.getCoachClients();
                    }
                    this.savingClient = false
                    
                    this.closeModal();
                    this.toastr.success('Client added successfully', 'ELI');
                    $('body').css('cursor', 'default');
                } else {
                    this.toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                    this.savingClient = false;
                }
            }

        });
    }

    /*Customize Modal*/
    openCustomizeModal() {
        $("#customizeModal").modal('show');
        this.sizeToFit(this.gridApiStandard);
    }

    closeCustomizeModal() {
        $("#customizeModal").modal('hide');
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onStandardGridReady(params) {
        this.gridApiStandard = params.api;
    }

    public onStandardRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.edit(data['Id'], true);
        }
    }

    getGlobalEmailTemplates() {
        this._TemplatesService.getGlobalEmailTemplates().subscribe((data: any) => {
            console.log('response_GetGlobalEmailTemplates', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.standardData = JSON.parse(data.result.Data);
                console.log('this.standardData', this.standardData);
                this.loading = true;
                setTimeout(() => {
                    console.log('CAROUSEL');
                    $('.carousel').carousel({
                        interval: 5000
                    })
                }, 500);
            }
        });
    }

    edit(id: number, isStandard: boolean) {
        console.log('edit', id);
        //this.router.navigate(['/app/edit_coach_email_template', id, isStandard]);
        this.currentTemplateId = id;
        this.PreviewEmailTemplate(id, 'en');
        //this.showPreviewEmailModal(id);
    }

    standardDataCreateHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let purposeHeader = {
            headerName: 'Purpose',
            field: 'Purpose',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(purposeHeader);

        let AssessmentTypeHeader = {
            headerName: 'Assessment Type',
            field: 'AssessmentType',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(AssessmentTypeHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        return columnDefs;
    }

    customizeTemplate() {
        this.customize = !this.customize;
        $("#customizable").toggleClass("displayNone");
        $("#notCustomizable").toggleClass("displayNone");
    }

    /*PREVIEW MODAL*/
    closePreviewModal() {
        $("#previewModal").modal("hide");
        $("#customizable").addClass("displayNone");
        $("#notCustomizable").removeClass("displayNone");
        this.customize = false;
    }

    showPreviewModal(templateId: number, type: string) {
        this.currentEditedType = type;
        console.log("templateId", templateId);
        if (templateId > 0) {
            this.currentTemplateId = templateId;
            this.getEmailTemplate(templateId);
        }
    }

    getEmailTemplate(currentTemplateId) {
        $('body, .material-icons').css('cursor', 'wait');
        this._TemplatesService.getEmailTemplate(currentTemplateId).subscribe((data: any) => {
            //console.log('response_GetEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetEmailTemplate', _data);

                this.name = _data.Name;
                $('#emailTemplateName').val(this.name);
                this.purpose = _data.Purpose;
                this.userType = _data.UserType;
                this.type = _data.AssessmentType;
                this.niche = _data.Niche; 
                this.localizations = _data.Localizations;
                this.htmlBody = this.localizations[0].Body;
                this.checkData(this.localizations[0].Language, this.localizations[0].Subject);

                this.PreviewEmailTemplate(currentTemplateId, "en");
            }
        });
    }

    PreviewEmailTemplate(currentTemplateId, language) {
        //let currentTemplateId = ;

        this._TemplatesService.postPreviewEmailTemplate(currentTemplateId, language).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('PreviewEmailTemplate', _data);
                this.body = _data.Body;
                this.subject = _data.Subject;
                this.getTemplateFields();

                $("#previewModal").modal({ backdrop: "static" });
                $('#previewModal').modal('show');

                $('#prevSubject').val(this.subject);
                $('#body').html(this.body);
                $('body, .material-icons').css('cursor', 'default');


                //$('#csubject').val(this.subject);
                //this.editorContent = this.body;
            }
        });
    }

    checkData(languageShortCode: string, subject: string) {

        $('#subject').val('');
        this.editorContent = '';

        //this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let exist = false;
        let pos = 0;
        for (var i = 0; i < this.localizations.length; i++) {
            if (languageShortCode == this.localizations[i].Language) {
                exist = true;
                pos = i;
            }
        }
        if (exist) {
            //load html content editor
            //load subject
            $('#csubject').val(this.localizations[pos].Subject);
            this.editorContent = this.localizations[pos].Body;
            console.log('LOCALIZATION VALUES:', this.localizations[pos].Subject, this.localizations[pos].Body);
        }

        $(".panel-body").focus();

    }

    onEditorBlured(quill) {
        console.log('editor blur!', quill);
    }

    onEditorFocused(quill) {
        console.log('editor focus!', quill);
    }

    onEditorCreated(quill) {
        this.editor = quill;
        console.log('quill is ready! this is current quill instance object', quill);
    }

    onContentChanged({ quill, html, text }) {
        //console.log('quill content is changed!', quill, html, text);
        this.htmlBody = html;
        console.log('html body', this.htmlBody);
    }

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
    };

    insertCustomFields(fieldName: string) {
        var range = this.editor.getSelection();
        if (range) {
            if (range.length == 0) {
                console.log('User cursor is at index', range.index);
            } else {
                var text = this.editor.getText(range.index, range.length);
                console.log('User has highlighted: ', text);
            }
            this.editor.insertText(range.index, `{${fieldName}}`, 'bold', true);

        } else {
            console.log('User cursor is not in editor');

            var length = this.editor.getLength();

            this.editor.insertText(length - 1, `{${fieldName}}`, 'bold', true);
        }
    }

    getTemplateFields() {
        this._AdminService.getTemplateFields().subscribe(data => {
            console.log('response_GetTemplateFields', data.result);
            this.templateFields = data.result;
        });
    }

    updateEmailTemplate(name: string, type: string, purpose: string, userType: string) {
        console.log('update email template');
        this.saveTemplate(name, type, purpose, "1", userType);
    }

    saveTemplate(name: string, type: string, purpose: string, niche: string, userType: string) {

        if (name == "") {
            this.toastr.warning('Name field empty', "ELI");
            return;
        }


        //adding localization if user not change the select
        let shortCode = $('#alanguages').val();
        let subject = $('#csubject').val();
        this.addLocalization(shortCode, subject);

        let enLocalization = false;

        if (this.localizations.length == 0) {
            this.toastr.warning('No localizations set', "ELI");
            return;
        } else {
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == "en") {
                    enLocalization = true
                }
            }
        }

        if (!enLocalization) {
            this.toastr.warning('English localization missing', 'ELI');
            return;
        }


        let emailTemplate = new EmailTemplateDto();
        emailTemplate.TemplateId = 0;//this.currentTemplateId;
        emailTemplate.Name = name;
        emailTemplate.AssessmentType = parseInt(type);
        emailTemplate.Purpose = parseInt(purpose);
        emailTemplate.UserType = parseInt(userType);
        emailTemplate.Niche = parseInt(niche);
        emailTemplate.Owner = this._Globals.getUserId();
        emailTemplate.Localizations = this.localizations;
        emailTemplate.IsGlobal = false;

        console.log('EMAIL TEMPLATE', emailTemplate);

        this._TemplatesService.postSaveEmailTemplate(emailTemplate).subscribe(data => {
            console.log('response_PostSaveEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this.toastr.success('Email template saved successfully', 'ELI');
                    this.getEmailTemplatesByAssessment(this.assessmentId);
                    this.setTheLastOption = true;

                    switch (this.currentEditedType) {

                        case 'clientInvitation':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(1, 3); //invitancion
                            this.invEma = true;
                            break;
                        case 'clientReminder':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(3, 3); //reminder
                            this.remEma = true;
                            break;
                        case 'clientResult':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(2, 3); //result
                            this.resEma = true;
                            break;
                        case 'raterInvitation':
                            //this.getEmailTemplatesByUserTypeByPurpose(4, 1); // rater invitation
                            this.getEmailTemplatesByUserByUserTypeByPurpose(1, 4);
                            this.ratInv = true;
                            break;
                        case 'raterReminder':
                            //this.getEmailTemplatesByUserTypeByPurpose(4, 3); // rater reminder
                            this.getEmailTemplatesByUserByUserTypeByPurpose(3, 4);
                            this.ratRem = true;
                            break;
                    }

                    //this.customTemplates = true;
                    //$('#checkbox1').prop('checked', true);
                    this.closePreviewModal();

                }

                if (data.result.Result == 0) {
                    this.toastr.error('We are sorry. An error happened while trying to save the email template.', 'ELI');
                }
            }
        });


    }

    getTemplatePurposes() {
        this._AdminService.getTemplatePurposes().subscribe((data: any) => {
            console.log('response_GetTemplatePurposes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                this.purposes = JSON.parse(data.result.Data);
            }
        });
    }

    getNiches() { 
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('respons_GetNiches', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;
            }
        });
    }

    getUserTypesByTemplateType() {
        this._AdminService.getUserTypesByTemplateType(2).subscribe((data: any) => {
            console.log('response_GetUserTypes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.userTypes = _data;
            }
        });
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;

            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    addLocalization(shortCode: string, subject: string) {
        //if (text != '') {
        console.log('addLocalization');
        if (subject == "") {
            this.toastr.warning('Subject field empty', 'ELI');
            return;
        }

        if (this.htmlBody == null) {
            this.toastr.warning('Email body empty', 'ELI');
            return;
        }

        if (this.localizations.length == 0) {
            let newLocalization = new LocalizationsEmailTemplate();
            newLocalization.Language = shortCode;
            newLocalization.Subject = subject;
            newLocalization.Body = this.htmlBody;

            this.localizations.push(newLocalization);
        }
        else {

            let addNew = true;
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == shortCode) {
                    //property exist
                    addNew = false;
                    this.localizations[i].Body = this.htmlBody;
                    this.localizations[i].Subject = subject;
                }
            }
            if (addNew) {
                //property not exist
                let newLocalization = new LocalizationsEmailTemplate();
                newLocalization.Language = shortCode;
                newLocalization.Subject = subject;
                newLocalization.Body = this.htmlBody;

                this.localizations.push(newLocalization);
            }
        }
        console.log(this.localizations);
        //}
    }


    /*ASSIGN MODAL METHODS*/
    showAssignModal(type: number) {
        this.currentAssessmentTypeSelected = type;
        $.fn.modal.Constructor.prototype.enforceFocus = function () { };
        $("#assignModal").modal({ backdrop: "static" });
        $('#assignModal').modal('show');
        $('#Tab2').removeClass('active in');
        $('#Tab1').addClass('active in');
        this.displayPageContent();
        this.getRaterTypesForCoach();
    }

    getRaterTypesForCoach() {
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raterTypes = _data;
                this.rater.RaterType.Id = _data[0].Id;
            }
        });
    }

    openTab(assessmentType, gridApi) {
        $('.assessmentTabs .tab-content div').removeClass('active');
        $('.assessmentTabs .tab-content div').removeClass('in');
        $('.assessmentTabs #Tab' + assessmentType).addClass('active');
        $('.assessmentTabs #Tab' + assessmentType).addClass('in');
        $('.assessmentTabs #assessmentTypes li').removeClass('active');
        if (assessmentType === 1) {
            $('.assessmentTabs #assessmentTypes li').eq(0).addClass('active');
        } else {
            $('.assessmentTabs #assessmentTypes li').eq(1).addClass('active');
        }
        setTimeout(() => {
            this.sizeToFit(this.assessmentsRegularGridApi);
        }, 500);
    }

    hideAssignModal() {
        $('#assignModal').modal('hide');
        $('.eTemplates li').removeClass('active').eq(0).addClass('active');
        $('.eTemplates div').removeClass('in active').eq(0).addClass('in active');
        this.currentPage = 1;
        this.deselectAllCheckBox(this.assessmentsRegularGridApi);
        this.deselectAllCheckBox(this.assessments360GridApi);
        //this.deselectAllCheckBox(this.clientsGridApi);
        this.saving = false;
        this.importedRaters = [];
        this.addedRaters = [];
        //this.raterGridApi.setRowData([]);
        this.invEma = false;
        this.remEma = false;
        this.resEma = false;
        this.ratInv = false;
        this.ratRem = false;
    }

    getSelectedRows(gridApi): any {
        return gridApi.getSelectedRows();
    }

    getEmailTemplatesByAssessment(assessmentId) {
        this._TemplatesService.getEmailTemplatesByAssessment(assessmentId).subscribe((data: any) => {
            console.log('response_getEmailTemplatesByAssessment', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                _data.forEach((template) => {
                    console.log(template);

                    switch (template.UserType) {
                        case 3:
                            switch (template.Purpose) {
                                case 1:
                                    //invitation
                                    this.templates.invitation = template;
                                    break;

                                case 3:
                                    //reminder
                                    this.templates.reminder = template;
                                    break;

                                case 2:
                                    //result
                                    this.templates.result = template;
                                    break;
                            }
                            break;

                        case 4:
                            switch (template.Purpose) {
                                case 1:
                                    //invitation
                                    this.raterTemplates.invitation = template;
                                    break;

                                case 3:
                                    //reminder
                                    this.raterTemplates.reminder = template;
                                    break;
                            }
                            break;
                    }

                });

            }
        });
    }

    //getEmailTemplatesByUserByPurpose(purpose: number) {
    //    this._TemplatesService.getEmailTemplatesByUserByPurpose(purpose).subscribe((data: any) => {
    //        console.log('response_GetEmailTemplatesByUserByPurpose', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('_data', _data);
    //            var lastIndex = _data.length - 1;

    //            switch (purpose) {
    //                case 1:
    //                    if (_data.length > 0) {
    //                        this.invitationTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.invitationTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.invitationTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //                case 3:
    //                    if (_data.length > 0) {
    //                        this.reminderTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.reminderTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.reminderTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //                case 2:
    //                    if (_data.length > 0) {
    //                        this.resultTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.resultTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.resultTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //            }
    //            this.setTheLastOption = false;

    //            if (this.currentEditedType !== "") {
    //                setTimeout(() => {
    //                    var length = $('#' + this.currentEditedType + ' > option').length;
    //                    $('#' + this.currentEditedType + ' :nth-child(' + length + ')').prop('selected', true);
    //                }, 100);
    //            }
    //        }
    //    });
    //}

    getEmailTemplatesByUserByUserTypeByPurpose(purpose: number, userType: number) {
        this._TemplatesService.getEmailTemplatesByUserByUserTypeByPurpose(purpose, userType).subscribe((data: any) => {
            console.log('response__getEmailTemplatesByUserByUserTypeByPurpose ' + purpose + userType, data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                var lastIndex = _data.length - 1;

                switch (userType) {
                    case 3: {
                        switch (purpose) {
                            case 1:
                                if (_data.length > 0) {
                                    this.invitationTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.invitationTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.invitationTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                            case 3:
                                if (_data.length > 0) {
                                    this.reminderTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.reminderTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.reminderTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                            case 2:
                                if (_data.length > 0) {
                                    this.resultTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.resultTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.resultTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                        }
                        break;
                    }
                    case 4: {
                        switch (purpose) {
                            case 1: {
                                if (_data.length > 0) {
                                    this.raterInvitations = _data;

                                    //if (this.raterInvitation == 0) {
                                    //    this.raterInvitation = this.raterInvitations[0].Id;
                                    //    this.raterTemplates.invitation = _data[0];
                                    //}

                                    if (this.setTheLastOption) {
                                        this.raterInvitation = _data[lastIndex].Id;
                                    } else {
                                        this.raterInvitation = _data[0].Id;
                                    }
                                }
                                break;
                            }

                            case 3: {
                                if (_data.length > 0) {
                                    this.raterReminders = _data;

                                    //if (this.raterReminder == 0) {
                                    //    this.raterReminder = this.raterReminders[0].Id;
                                    //    this.raterTemplates.reminder = _data[0];
                                    //}

                                    if (this.setTheLastOption) {
                                        this.raterReminder = _data[lastIndex].Id;
                                    } else {
                                        this.raterReminder = _data[0].Id;
                                    }
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
                this.setTheLastOption = false;

                if (this.currentEditedType !== "") {
                    setTimeout(() => {
                        var length = $('#' + this.currentEditedType + ' > option').length;
                        $('#' + this.currentEditedType + ' :nth-child(' + length + ')').prop('selected', true);
                    }, 100);
                }
            }
        });
    }

    confirmationSave() {
        if (this.is360) {
            console.log('display confirmation popup modal');
            this.showConfirmationSaveModal()
            return;
        } else {
            this.saveAssessmentAssignment();
        }
    }

    confirmationDenied() {
        this.processfinished();
    }

    changeCustomTemplateStatus() {
        this.customTemplates = !this.customTemplates;
        console.log(this.customTemplates);
    }

    saveAssessmentAssignment() { 
        if (this.saving) {
            return;
        }

        this.saving = true;
        $('body').css('cursor', 'wait');

        let assessmentAssignment = new AssessmentAssignmentDto;
        assessmentAssignment.CoachId = this._Globals.getUserId();
        assessmentAssignment.AssessmentId = this.assessmentId;
        assessmentAssignment.Language = this.language;

        var d = new Date();
        var n = d.getTimezoneOffset();
        this.selectedGtmValue = (n / 60);
        assessmentAssignment.TimeOffset = this.selectedGtmValue; 
        
        if (this.expiresIn > 30) this.expiresIn = 30;
        assessmentAssignment.ExpiresIn = this.expiresIn;

        if (this.scheduleSelected === "0") {
            assessmentAssignment.SendNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            assessmentAssignment.ScheduledDate = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            assessmentAssignment.ScheduledTime = currentHour[0] + ":00 " + currentHour[1];
        } else {
            assessmentAssignment.SendNow = false;
            //var sDate = this.scheduledDate.split('/');
            //assessmentAssignment.ScheduledDate = sDate[1] + '/' + sDate[2] + '/' + sDate[0];
            //assessmentAssignment.ScheduledTime = this.selectedHour;
            let scheduledFor = $('.wc-date-container span').text();
            //let scheduledForArr = scheduledFor.split(' ');
            //scheduledFor = scheduledForArr[3];
            //scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            //assessmentAssignment.ScheduledTime = scheduledFor + " " + this.selectedHour;
            assessmentAssignment.ScheduledDate = scheduledFor;
            assessmentAssignment.ScheduledTime = this.selectedHour;;
        }

        assessmentAssignment.ClientIds = this.clientIds;
        assessmentAssignment.UseCustomEmailTemplates = this.customTemplates;

        let emailTemplates = [];
        //if (this.customTemplates) {

        //    emailTemplates = [
        //        { "TemplateId": this.invitationTemplatesModel, "Purpose": 1 },
        //        { "TemplateId": this.resultTemplatesModel, "Purpose": 2 },
        //        { "TemplateId": this.reminderTemplatesModel, "Purpose": 3 },
        //        { "TemplateId": this.raterInvitation, "Purpose": 1 },
        //        { "TemplateId": this.raterReminder, "Purpose": 3 }
        //    ];

        //EMAIL INVITATION
        if (!this.invEma) {
            console.log(this.templates.invitation);
            let templateId = $('.invEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.invitation.Purpose,
                "UserType": this.templates.invitation.UserType
            });
        } else {
            console.log(this.invitationTemplates);
            let i = $("#clientInvitation").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.invitationTemplatesModel,
                "Purpose": this.invitationTemplates[i].PurposeId,
                "UserType": this.invitationTemplates[i].UserType
            })
        }

        //EMAIL REMAINDER
        if (!this.remEma) {
            console.log(this.templates.reminder);
            let templateId = $('.remEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.reminder.Purpose,
                "UserType": this.templates.reminder.UserType
            });
        } else {
            console.log(this.reminderTemplates);
            let i = $("#clientReminder").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.reminderTemplatesModel,
                "Purpose": this.reminderTemplates[i].PurposeId,
                "UserType": this.reminderTemplates[i].UserType
            })
        }

        //EMAIL RESULT
        if (!this.resEma) {
            console.log(this.templates.result);
            let templateId = $('.resEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.result.Purpose,
                "UserType": this.templates.result.UserType
            });
        } else {
            console.log(this.resultTemplates);
            let i = $("#clientResult").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.resultTemplatesModel,
                "Purpose": this.resultTemplates[i].PurposeId,
                "UserType": this.resultTemplates[i].UserType
            })
        }

        if (this.is360) {
            //360 RATER INVITATION
            if (!this.ratInv) {
                console.log(this.raterTemplates.invitation);
                let templateId = $('.ratInv').attr('id');
                emailTemplates.push({
                    "TemplateId": parseInt(templateId),
                    "Purpose": this.raterTemplates.invitation.Purpose,
                    "UserType": this.raterTemplates.invitation.UserType
                });
            } else {
                console.log(this.raterInvitations);
                let i = $("#raterInvitation").prop('selectedIndex');
                emailTemplates.push({
                    "TemplateId": this.raterInvitation,
                    "Purpose": this.raterInvitations[i].PurposeId,
                    "UserType": this.raterInvitations[i].UserType
                })
            }

            //360 RATER REMINDER
            if (!this.ratRem) {
                console.log(this.raterTemplates.reminder);
                let templateId = $('.ratRem').attr('id');
                emailTemplates.push({
                    "TemplateId": parseInt(templateId),
                    "Purpose": this.raterTemplates.reminder.Purpose,
                    "UserType": this.raterTemplates.reminder.UserType
                });
            } else {
                console.log(this.raterReminders);
                let i = $("#raterReminder").prop('selectedIndex');
                emailTemplates.push({
                    "TemplateId": this.raterReminder,
                    "Purpose": this.raterReminders[i].PurposeId,
                    "UserType": this.raterReminders[i].UserType
                })
            }
        }

        let allSelected: boolean = true;
        emailTemplates.forEach((item) => {
            if (isNaN(item.TemplateId)) {
                this.toastr.warning("Please select a value for all of the email template types.", "ELI");
                $('body').css('cursor', 'default');
                this.saving = false;
                allSelected = false;
            }
        });
        //}

        if (!allSelected) return;

        assessmentAssignment.EmailTemplates = emailTemplates;

        let tags = [];
        this.tags.forEach((tag) => {
            tags.push(tag.value);
        });
        assessmentAssignment.Tags = tags;

        let raters = [];
        if (this.addedRaters.length > 0) {
            this.addedRaters.forEach(item => {
                delete item.RaterTypeName;
                raters.push(item);
            });
        }

        assessmentAssignment.Raters = raters;

        let metaData = [];
        metaData.push({
            AssignmentId: 0,
            MetaKey: "TIME_OFFSET",
            MetaValue: this.selectedGtmValue
        });
        assessmentAssignment.MetaData = metaData;
        //this.saving = false;

        console.log('assessmentAssignment', assessmentAssignment);

        this._CoachService.postSaveAssessmentAssignment(assessmentAssignment).subscribe(data => {
            console.log('response__SaveAssessmentAssignment', data.result);
            if (data.result.Result == 1) {
                let message360 = "";
                if (this.is360) {
                    message360 = " All invitation emails for the client and raters have been sent.";
                }
                this.toastr.success('Assessment assigned successfully.' + message360, 'ELI');
                this.processfinished();
            } else if (data.result.Result == -1) {
                this.toastr.error('We are sorry.  We cannot create the assign assessment for the selected clients since at least one of the selected Email Templates does not have a version available for the selected Language', 'ELI');
            } else {
                this.toastr.error('We are sorry.An error happened while trying to assign the assessment to the selected clients', 'ELI');
            }

            $('body').css('cursor', 'default');
            this.saving = false;
        });


    }

    processfinished() {
        this.hideAssignModal();
        this.closeConfirmationSaveModal();
        this.deselectAllCheckBox(this.clientsGridApi);
        this.getCoachDashboardInfo();
        this.getCoachAvailableAssessmentsByType(1);
        this.getCoachAvailableAssessmentsByType(2);
    }

    /*------------------confirmation modal--------------------*/

    showConfirmationSaveModal() {
        $("#confirmationModal").modal({ backdrop: "static" });
        $('#confirmationModal').modal('show');
    }

    closeConfirmationSaveModal() {
        $('#confirmationModal').modal('hide');
    }

    goTo(path) {
        $('li').eq(0).removeClass('active');

        switch (path) {
            case "/app/clients":
                $('li').eq(1).addClass('active');
                break;

            case "/app/coach_assessments":
                $('li').eq(2).addClass('active');
                this._Globals.showCompletedAssessments = true;
                break;

            case "/app/cemails":
                $('li').eq(3).addClass('active');
                break;
        }

        this.router.navigate([path]);
    }

    onDateSelect(date) {

        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log("today", today);

        if (date < today) {
            this.toastr.warning("Please enter a date and time greater than the current date and time.", "ELI");
            this.date1 = new Date();

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            currentHour[0] = parseInt(currentHour[0]);
            if (currentHour[0] == 12) {
                currentHour[0] = 0;
            }
            currentHour[0] = (currentHour[0] + 1) + "";

            if (currentHour[0].length == 1) {
                currentHour[0] = "0" + currentHour[0];
            }

            if (currentHour[0] == 12) {
                currentHour[1] = "PM";
            }
            currentHour = currentHour[0] + ":00 " + currentHour[1];
            console.log('current Hour', currentHour);
            $('#hour').val(currentHour);
        }
    }




    //--------assessments-------------------------------
    //getCoachAvailableAssessments() {
    //    this._GetCoachAvailableAssessments.GetCoachAvailableAssessments(this._Globals.getUserId()).subscribe(data => {
    //        console.log('response_GetCoachAvailableAssessments', data.result);
    //        this.assessments = data.result;
    //        //this.loading = false;
    //    });
    //}

    getCoachAvailableAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
            console.log('response_GetRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this.assessmentsELIData = _data;
                } else {
                    this.assessments360Data = _data;
                }

            }

        });
    }

    createAssessmentsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        let version = params.data['MajorVersion'] + "." + params.data['MinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(quantityHeader);

        return columnDefs;
    }

    onGridReady(grid, params) {
        if (grid === 1) {
            this.assessmentsRegularGridApi = params.api;
        } else {
            this.assessments360GridApi = params.api;
        }
    }

    selectedTab(index:number) {
        console.log(index);
        switch (index) {
            case 1:
                this.sizeToFit(this.assessmentsRegularGridApi);
                this.deselectAllCheckBox(this.assessments360GridApi);
                break;
            case 2:
                this.sizeToFit(this.assessments360GridApi);
                this.deselectAllCheckBox(this.assessmentsRegularGridApi);
                break;
        }
    }

    onAssessessmentRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
        }
    }

    onAssessmentsSelectionChanged(grid, event) {

        console.log("onSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (grid === 1) {
            this.selectedAssessment = this.getSelectedRows(this.assessmentsRegularGridApi);
        } else {
            this.selectedAssessment = this.getSelectedRows(this.assessments360GridApi);
        }

            console.log("selected Assessment", this.selectedAssessment);


    }



    //----------clients----------------------------------
    getCoachClients() {
        this._CoachService.getCoachClients().subscribe((data: any) => {
            console.log('response_GetCoachClients', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.clients = _data;
            }
        });
    }

    createHeaders() {
        let columnDefs = new Array();

        let emptyHeader = {
            headerName: '',
            field: '',
            headerCheckboxSelection: this.showCheckBox,
            headerCheckboxSelectionFilteredOnly: this.showCheckBox,
            checkboxSelection: this.showCheckBox,
            minWidth: 30,
            width: 30,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emptyHeader);
        

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            //headerCheckboxSelection: true,
            //headerCheckboxSelectionFilteredOnly: true,
            //checkboxSelection: true,
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(lastNameHeader);

        return columnDefs;
    }

    onClientsGridReady(params) {
        this.clientsGridApi = params.api;
    }

    onClientsRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
        }
    }

    onClientsSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        let nodes = event.api.getSelectedNodes();
        var rowCount = nodes.length;

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedClients = this.getSelectedRows(this.clientsGridApi);
        console.log("selected Clients", this.selectedClients);

        this.currentAmount = this.amount - rowCount;
        if (this.currentAmount < 0) {
            this.enoughAmount = false;
            this.toastr.warning("You don't have enough assessments to assign to the selected clients.", "ELI");

            //var model = event.api.getModel();
            //var rowNode = model.rowsToDisplay[1];
            //this.currentNode.setSelected(false);
            //this.currentgridApi;
            this.clientsGridApi.forEachNode((node) => {
                //let contains = this.containsObject(node.data.Id, this.selectedClients);
                let a = this.selectedClientsIds.indexOf(node.data.Id);
                if (a == -1) {
                    node.setSelected(false);
                }
            });

        } else {
            let selectedClients = this.getSelectedRows(this.clientsGridApi);
            this.selectedClientsIds = [];
            selectedClients.forEach((item) => {
                console.log(item);
                this.selectedClientsIds.push(item.Id);
            });

            console.log(this.selectedClientsIds);
        }

        if (!this.enoughAmount) {
            this.enoughAmount = true;
        }
    }

    nextContent() {
        //validation before continue
        switch (this.currentPage) {
            case 1:
                if (this.selectedAssessment.length == 0) {
                    this.toastr.warning("Please select an Assessment.", "ELI");
                    return;
                } else {
                    if (!this.selectedAssessment[0].Is360) {
                        this.clientsRowSelection = "multiple";
                        this.showCheckBox = true;
                    } else {
                        this.clientsRowSelection = "single";
                        this.showCheckBox = false;
                    }
                }
                break;

            case 2:
                this.ratersHeaders = this.createRatersHeaders();

                if (this.selectedClients.length == 0) {
                    this.toastr.warning("Please at least one client.", "ELI");
                    return;
                } else {
                    this.clientIds = [];
                    var selectedClients = this.getSelectedRows(this.clientsGridApi);
                    selectedClients.forEach((question) => {
                        console.log(question);
                        this.clientIds.push(question.ClientId);
                    });
                    console.log("Selected Client ids:", this.clientIds);
                }
                break;
            case 3:
                console.log("Row Data:", this.addedRaters);
                break;
        }
        
        if (this.currentPage == 2 && !this.is360) {
            this.currentPage += 2;
            this.displayPageContent();
        } else {
            if (this.is360 && this.currentPage == 3) {
                this.getCheckRatersTypesMinimum();
            } else {
                this.currentPage++;
                this.displayPageContent();
            }
        }
        console.log('current page:',this.currentPage);
    }

    prevContent() {
        if (this.currentPage >= 2) {
            if (this.currentPage == 4 && !this.is360) {
                this.currentPage -= 2;
            } else {
                this.currentPage--;
            }
            //this.currentPage--;
            console.log('currentPage', this.currentPage);
        }
    }

    displayPageContent() {
        switch (this.currentPage) {
            case 1:
                this.assessmentsHeaders = this.createAssessmentsHeaders();
                let gridApi;
                if (this.currentAssessmentTypeSelected === 1) {
                    gridApi = this.assessmentsRegularGridApi;
                    this.openTab(this.currentAssessmentTypeSelected, gridApi);
                } else {
                    gridApi = this.assessments360GridApi;
                    this.openTab(this.currentAssessmentTypeSelected, gridApi);
                }
                break;

            case 2:

                this.clientsHeaders = this.createHeaders();
                this.sizeToFit(this.clientsGridApi);
                this.deselectAllCheckBox(this.clientsGridApi);

                //reading the assessment properties
                this.assessmentName = this.selectedAssessment[0].AssessmentName;
                this.amount = this.selectedAssessment[0].Amount; 
                this.currentAmount = this.amount;
                this.assessmentId = this.selectedAssessment[0].AssessmentId;
                this.is360 = this.selectedAssessment[0].Is360;
                console.log("assessmentName", this.assessmentName);
                console.log("amount", this.amount);
                console.log("assessmentId", this.assessmentId);
                console.log("is360", this.is360);
                //$('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
                setTimeout(() => {
                    $('.ag-floating-filter-input').eq(0).closest('.ag-header-cell').hide();
                }, 10);
                setTimeout(() => {
                    $(".ag-floating-filter-input").attr("placeholder", "Filter");
                }, 100);

                this.templates = {
                    invitation: "",
                    reminder: "",
                    result: ""
                }

                this.raterTemplates = {
                    invitation: "",
                    reminder: ""
                }

                this.getEmailTemplatesByUserByUserTypeByPurpose(1, 3);
                this.getEmailTemplatesByUserByUserTypeByPurpose(3, 3);
                this.getEmailTemplatesByUserByUserTypeByPurpose(2, 3);

                //this.getEmailTemplatesByUserTypeByPurpose(4, 1); // rater invitation
                //  this.getEmailTemplatesByUserTypeByPurpose(4, 3); // rater reminder

                this.getEmailTemplatesByUserByUserTypeByPurpose(1, 4);
                this.getEmailTemplatesByUserByUserTypeByPurpose(3, 4);

                setTimeout(() => {
                    var time = new Date();
                    let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                    currentHour = currentHour.split(' ');
                    this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1]);
                }, 100);

                //getting the email templates
                this.getEmailTemplatesByAssessment(this.assessmentId);
                break;

            case 3:
                break;
            case 4:
                this.scheduledDate = $('.wc-date-container span').text();
                this.scheduledDate = this.scheduledDate.slice(0, 10);
                this.scheduledDate = this.scheduledDate.replace(/-/g, "/");
                console.log('scheduledFor', this.scheduledDate);

                this.language = $('#languages').val();
                console.log('language', this.language);

                this.expiresIn = $('#expiresIn').val();
                console.log('expiresIn', this.expiresIn);

                this.selectedHour = $('#hour').val();
                //this.selectedGtmText = $("#gtm option:selected").text();
                //this.selectedGtmValue = $('#gtm').val();
                this.scheduleSelected = $("input[name='schedule']:checked").val();

                console.log(this.selectedHour);
                console.log(this.scheduleSelected);
                break;
        }
    }

    addNewHour(minHour: number, type: string) {

        if (minHour == 13) {
            minHour = 1;
        }

        let amHours = [];
        let pmHours = [];

        if (type === "AM") {
            for (var i = minHour; i <= 11; i++) {
                if (i >= 10) {
                    amHours.push( i + ":00 AM");
                } else {
                    amHours.push("0"+ i +":00 AM");
                }
            }
            //adding the rest pm hours
            amHours.push("12:00 PM");
            minHour = 1;
            for (var j = minHour; j < 12; j++) {
                if (j >= 10) {
                    pmHours.push( j + ":00 PM");
                } else {
                    pmHours.push("0" + j + ":00 PM");
                }
            }
        } else {
            if (minHour == 12) {
                amHours.push("12:00 PM");
                minHour = 1;
            }
            for (var i = minHour; i < 12; i++) {
                if (i >= 10) {
                    pmHours.push( i + ":00 PM");
                }else {
                    pmHours.push("0" + i + ":00 PM");
                }
            }
        }
        console.log("this.hours", this.hours);
        this.hours = amHours.concat(pmHours);
        //$('#hour').val(currentHour);

    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    /*Import Modal*/

    showImportModal(type:number) {
        $('#importModal').modal('show');
        this.importType = type;
    }

    closeImportModal() {
        $('#importModal').modal('hide');
        $('#iFile').val('');
        this.fileName = "";
        this.blobFile = null;
    }

    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        let str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];

        //1 clients
        //2 raters
        if (this.importType == 2) {
            this.csv2Array(event);
        }
    }

    okImportClients() {
        if (this.importType != 2) {
            if (this.blobFile != null) {
                $('body').css('cursor', 'wait');
                this.blobToBase64(this.blobFile);
            } else {
                this.toastr.warning("Please select an a .csv file.", "ELI");
            }
        } else {
            this.importedRaters.forEach(rater => {
                this.addNewRater(rater, true);
            });

            this.closeImportModal();
        }
        
    }

    csv2Array(fileInput: any) {
        //read file from input
        let fileReaded = fileInput.target.files[0];

        let reader: FileReader = new FileReader();
        reader.readAsText(fileReaded);

        reader.onload = (e) => {
            let csvF: any = reader.result;
            let allTextLines = csvF.split(/\r|\n|\r/);
            let headers = allTextLines[0].split(',');
            let lines = [];

            for (let i = 0; i < allTextLines.length; i++) {
                // split content based on comma
                let data = allTextLines[i].split(',');
                if (data.length === headers.length) {
                    let tarr = [];
                    for (let j = 0; j < headers.length; j++) {
                        tarr.push(data[j]);
                    }

                    // log each row to see output 
                    console.log(tarr);
                    lines.push(tarr);
                }
            }
            // all rows in the csv file 
            console.log(">>>>>>>>>>>>>>>>>", lines);
            lines.forEach(element => {
                let type: any = element[3];

                console.log(typeof type);

                this.checkArr(type);

                this.importedRaters.push({
                    Email: element[0],
                    RaterType: this.currentRatertype,
                    FirstName: element[1],
                    LastName: element[2]
                })

                //this.addNewRater(newRater, true);

            });
        }
    }

    checkArr(raterType: string) {
        let currentRatertype = this.raterTypes.find(i => i.Name == raterType);
        if (isUndefined(currentRatertype)) {
            this.currentRatertype = "";
        } else {
            this.currentRatertype = currentRatertype;
        }
        console.log("currentRatertype", this.currentRatertype);
    }

    blobToBase64(blobFile) {
        var reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
            console.log("Base64 file", reader.result);
            let base64file: any = reader.result.toString();
            base64file = base64file.split(',');
            this.importClients(base64file[1].toString());
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
            $('body').css('cursor', 'default');
        };
    }

    importClients(base64file: string) {
        this._CoachService.postImportClients(base64file).subscribe((data: any) => {
            console.log('response_PostImportClients', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_PostImportClients data', _data);

                switch (data.result.Result) {
                    case -5:
                        this.toastr.error("We are sorry. The specified file does not include any valid client. Please check that the First Names and Last Names values only include alphanumeric characters and that the the email addresses are valid.", "ELI");
                        break;

                    case -4:
                        this.toastr.error("Some clients could not be imported. We sent you an email with the details about the import process.", "ELI");
                        break;

                    case -3:
                        this.toastr.error("Invalid file format. Please be sure that you included the 'Email', 'First Name' and 'Last Name' columns. Please notice that headers names are case sensitive.", "ELI");
                        break;

                    case -2:
                        this.toastr.error("We are sorry. You don't have enough available assessments for the number of clients included in the file.", "ELI");
                        break;

                    case 0:
                        this.toastr.error("We are sorry. An unexpected error happened while trying to import the clients.", "ELI");
                        break;

                    case 1:
                        this.toastr.success("Clients imported successfully.", "ELI");
                        this.getCoachClients();
                        break;
                }

                this.closeImportModal();
                $('body').css('cursor', 'default');
            }
        });
    }

    hourChanged() {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);
    }

    addNewRater(rater: any, fromImport: boolean) {
        
        let newRater = {
            RaterId: 0,
            Email: rater.Email,
            ClientId: this._Globals.getUserId(),
            RaterTypeName: rater.RaterType.Name,
            RaterType: rater.RaterType.Id,
            FirstName: rater.FirstName,
            LastName: rater.LastName
        }

        if (!fromImport) {
            if (newRater.Email == "" || newRater.FirstName == "" || newRater.LastName == "") {
                this.toastr.warning('Empty fields', 'ELI');
                return;
            }
        }

        if (!this.validateEmail(newRater.Email)) {
            if (!fromImport) {
                this.toastr.warning('Please enter a valid email address', "ELI");
            }
            return;
        }

        console.log("New Rater", newRater);


        let pos = this.addedRaters.map(function (e) { return e.Email; }).indexOf(newRater.Email);
        if (pos == -1 || this.relationshipAction == "Edit") {

            if (this.relationshipAction == "Add") {
                var res = this.raterGridApi.updateRowData({ add: [newRater] });
            } else {
                //delete the current edited row and add a new one
                this.deleteRaters();
                var res = this.raterGridApi.updateRowData({ add: [newRater], addIndex: this.rowNodeId });
            }

            this.addedRaters.push(newRater);

            console.log('added');
            this.closeNewRaterModal();
            setTimeout(() => {
                this.sizeToFit(this.raterGridApi);
            }, 10);

            console.log("addedRaters", this.addedRaters);
            
        } else {
            console.log('Exist, not added');
            if (!fromImport) {
                this.toastr.warning("You have already entered this person as a rater for this assignment.", "ELI");
            }
        }
    }

    validateEmail(email: string): boolean {
        console.log("email", email);

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) return true;
        else {
            return false;
        }
    }

    onRaterGridReadyModal(params) {
        this.raterGridApi = params.api;
        this.sizeToFit(this.raterGridApi);
    }

    createRatersHeaders() {
        let columnDefs = new Array();
        //[{
        //    "RaterId": 0,
        //    "Email": "RATER EMAIL",
        //    "AssignedBy": ASSIGNED_BY,
        //    "RaterType": RATER_TYPE,
        //    "FirstName": "FIRST_NAME",
        //    "LastName": "LAST_NAME"
        //}]

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 200,
            width: 255,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let raterTypeHeader = {
            headerName: 'Relationship',
            field: 'RaterTypeName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(raterTypeHeader);

        let firstNameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(firstNameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(lastNameHeader);


        return columnDefs;
    }

    saveRater() {

        let id = $('#raterTypesSelect').val();
        let name = $("#raterTypesSelect option:selected").text();

        let newRater = {
            Email: this.rater.email,
            FirstName: this.rater.firstName,
            LastName: this.rater.lastName,
            RaterType: {
                Id: id,
                Name: name
            }
        }
        this.addNewRater(newRater, false); 
        
    }

    showNewRaterModal(action: string) {
        this.relationshipAction = action;

        if (this.relationshipAction == "Add") {
            this.rater.email = "";
            this.rater.firstName = "";
            this.rater.lastName = "";
            $('#raterTypesSelect option').eq(0).prop('selected', true);
        } else {
            let selectedRaters = this.getSelectedRows(this.raterGridApi);
            console.log(selectedRaters);

            this.rater.email = selectedRaters[0].Email;
            this.rater.firstName = selectedRaters[0].FirstName;
            this.rater.lastName = selectedRaters[0].LastName;
            $('#raterTypesSelect').val(selectedRaters[0].RaterType);
        }
        
        $("#addModal").modal({ backdrop: "static" });
        $('#addModal').modal('show');
    }

    closeNewRaterModal() {
        $('#addModal').modal('hide');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }

    onRaterRowClicked(e) {
        console.log(e);
    }

    onSelectionChangedForRaters(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount >= 1) {
            this.canDeleteRaters = true;
        } else {
            this.canDeleteRaters = false;
        }

        if (rowCount == 1) {
            this.canEdit = true;
            //getting current row index
            //var size = Object.keys(event.api.selectionController.selectedNodes).length;
            //for (let i = 1; i == size; i++) {
            //    if (event.api.selectionController.selectedNodes[i] !== undefined) {
            //        this.rowNodeId = event.api.selectionController.selectedNodes[i].rowIndex;
            //        console.log(this.rowNodeId);
            //    }
            //}
            let node = this.raterGridApi.getSelectedNodes();
            this.rowNodeId = node[0].rowIndex;
            console.log('getSelectedNodes', this.rowNodeId );
        } else {
            this.canEdit = false;
        }
    }

    showDeleteRatersConfirmationModal() {
        console.log('showDeleteRatersConfirmationModal');
        if (this.canDeleteRaters) {
            $("#confirmDeleteRatersModal").modal({ backdrop: "static" });
            $('#confirmDeleteRatersModal').modal('show');
        }
    }

    hideDeleteRatersConfirmationModal() {
        $('#confirmDeleteRatersModal').modal('hide');
    }

    confirmDeleteRaters() {
        this.deleteRaters();
    }

    deleteRaters() {
        let selectedRaters = this.getSelectedRows(this.raterGridApi);
        var res = this.raterGridApi.updateRowData({ remove: selectedRaters });

        this.addedRaters = [];
        this.raterGridApi.forEachNode((node) => {
            this.addedRaters.push(node.data);
        });

        this.hideDeleteRatersConfirmationModal();

        console.log("addedRaters", this.addedRaters);
    }

    /*raterTypesForModal*/
    openRaterTypesForModal() {
        this.raterTypesForModal.show(this, 1);
    }

    /*validation for raters*/
    getCheckRatersTypesMinimum() {
        console.log('this.addedRaters', this.addedRaters);
        var uniqueArray = [];
        $.each(this.addedRaters, function (i, el) {
            if ($.inArray(el.RaterType, uniqueArray) === -1) uniqueArray.push(el.RaterType);
        });
        let addedRaters = uniqueArray.join();
        console.log('uniqueArray', addedRaters);

        this._RatersService.getCheckRatersTypesMinimum(addedRaters).subscribe((data: any) => {
            console.log('response_getCheckRatersTypesMinimum', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                if (_data) {
                    this.currentPage++;
                    this.displayPageContent();
                } else {
                    this.toastr.warning("You need to enter 3 rater minimum except for Manager and Direct Report categories", "ELI");
                }
            }
        })
    }

    //openAssignModal() {
        
    //    console.log(this.selectedAssessment);
    //    let data = this.selectedAssessment[0];

    //    if (!isUndefined(data)) {
    //        this._Globals.closeHomeAssignModal = true;
    //        this.modalIndex = 1;
    //        this.assignAssessmentModal.show(this, false, data.Is360, data.Amount, data.AssessmentName, data.AssessmentId, undefined);
    //    } else {
    //        this.toastr.warning('Please select one assessment to assign.', 'ELI');
    //    }

    //}

    showVideoModal(title: string, description: string, videoUrl: string) {
        this.playingVideo = true;
        this.currentVideoUrl = videoUrl;
        this.createVideo(videoUrl);

        this.videoModalTitle = title;
        this.videoModalDescription = description;
        //$("#videoModal").modal({ backdrop: "static" });
        $('#videoModal').modal('show');
    }

    

    showAnnouncementsModal() {
        $("#announcementsModal").modal({ backdrop: "static" });
        $('#announcementsModal').modal('show');
    }


    hideAnnouncementsModal() {
        $('#announcementsModal').modal('hide');
        this._Globals.setAnnouncementsStatus(false);
    }

    sideScroll(element, direction, speed, distance, step) {
        let scrollAmount = 0;
        var slideTimer:any = setInterval(function () {
            if (direction == 'left') {
                element.scrollLeft -= step;
                //$('.movilWrap').scrollLeft(100);
            } else {
                element.scrollLeft += step;
                //$('.movilWrap').scrollRight(100);
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    scrollLeft() {
        var container = document.getElementsByClassName('movilWrap');
        this.sideScroll(container[0], 'left', 25, 200, 10);
    }

    scrollRight() {
        var container = document.getElementsByClassName('movilWrap');
        this.sideScroll(container[0], 'right', 25, 200, 10);
    }

    closeVideoModal(){
        $('.video-container video').remove();
        this.playingVideo = false;
    }

    nextAnnouncment() {
        console.log('next');
        if (this.currentAnnouncementIdx === this.announcements.length-1) {
            //this.currentAnnouncement = this.announcements[0].Text;
            //this.currentAnnouncementIdx = 0;
            this.displayNextArrow = false;
            this.displayBackArrow = true;
        } else {
            this.currentAnnouncement = this.announcements[this.currentAnnouncementIdx + 1].Text;
            this.currentAnnouncementIdx = this.currentAnnouncementIdx + 1;
            if (this.currentAnnouncementIdx === this.announcements.length - 1) {
                this.displayNextArrow = false;
            } else {
                this.displayNextArrow = true;
            }            
            this.displayBackArrow = true;
        }        
    }

    prevAnnouncement() {
        console.log('prev');
        if (this.currentAnnouncementIdx === 0) {
            //this.currentAnnouncement = this.announcements[this.announcements.length-1].Text;
            //this.currentAnnouncementIdx = this.announcements.length - 1;
            this.displayBackArrow = false;
            this.displayNextArrow = true;
        } else {
            this.currentAnnouncement = this.announcements[this.currentAnnouncementIdx - 1].Text;
            this.currentAnnouncementIdx = this.currentAnnouncementIdx - 1;
            if (this.currentAnnouncementIdx === 0) {
                this.displayBackArrow = false;
            } else {
                this.displayBackArrow = true;
            }            
            this.displayNextArrow = true;
        }
    };

    ssoShopify() {
        this._CoachService.ssoELIShopy().subscribe((data: any) => {
            console.log('ssoELIShopy', data);
/*            if (this._Globals.validationToken(data.result.Result)) {*/
            /*                let _data = JSON.parse(data.result.Data);*/
            console.log('data', btoa(data));
            $("#ssoContent").html(data);
/*            }*/
        })
    }

    getUserPersonalData() {
        $('body').css('cursor', 'wait');

        this._AdminService.getUserPersonalData(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            $('body').css('cursor', 'default');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                $("input[name='first_name']").val(_data.vg6);
                $("input[name='last_name']").val(_data.hj7);
                $("input[name='user_email']").val(_data.sr3);
                $("input[name='contact_id']").val(_data.by3);

                if (_data.by3 != "0") {
                    this.ssoToShopify();
                }
                else {
                    this.toastr.warning('You are not authorized to access the requested page', "ELI");
                }
            }
        })
    }

    ssoToShopify() {
        var shopifyForm:any = document.getElementById('shopifyForm');
        shopifyForm.submit();
    }
}
